import React, { useState, useRef,useEffect  } from 'react';
import '../App.css'; 

const Step1 = ({ onNext,data  }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    dob: '',
    maritalStatus: '',
    postalAddress: '',
    residentialAddress: '',
    phoneNo: '',
    cellNo: '',
    email: '',
    nationality: '',
    citizenship: '',
    ethnicity: '',
    homeLanguage: '',
    idOrPassportNo: '',
    visaPermitStatus: '',
    churchAffiliation: '',
    occupation: '',
    highestEducationLevel: '',
    disability: '',
    otherInstitution: '',
    howDidYouHear: '',
  });

  const [unfilledFields, setUnfilledFields] = useState([]);

  const containerRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  
  useEffect(() => {
    // Set the initial form data only when the component mounts
    setFormData((prevData) => ({ ...prevData, ...data }));
  }, []); // Empty dependency array ensures this runs only on mount


  const handleNext = () => {
  
    // Check if all required inputs are filled before moving to the next step
    const unfilled = Object.entries(formData)
      .filter(([key, value]) => value === '')
      .map(([key]) => key);

    if (unfilled.length === 0) {

      onNext({formData});

    } else {
      // Highlight unfilled fields with a red border
      setUnfilledFields(unfilled);

      // Scroll to the first unfilled required field
      const firstUnfilledField = document.getElementsByName(unfilled[0])[0];
      if (firstUnfilledField) {
        firstUnfilledField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
       // Alert if there are unfilled fields
    alert(`Please fill in the following fields: ${unfilled.join(', ')}`);
    }
  };

  return (
    <div className="container" ref={containerRef}>
      <div className="form-container">
        <h2>Step 1 of 3: Personal Details</h2>

        <label>
          Names and Surname<span className="required-indicator">*</span>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleInputChange}
            className={unfilledFields.includes('fullName') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          DOB<span className="required-indicator">*</span>:
          <input
            type="date"
            name="dob"
            value={formData.dob}
            onChange={handleInputChange}
            className={unfilledFields.includes('dob') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Marital Status<span className="required-indicator">*</span>
          <select
            name="maritalStatus"
            value={formData.maritalStatus}
            onChange={handleInputChange}
            className={unfilledFields.includes('maritalStatus') ? 'unfilled' : ''}
            required
          >
            <option value="">Select</option>
            <option value="Married">Married</option>
            <option value="Single">Single</option>
            <option value="Widowed">Widowed</option>
            <option value="Divorced">Divorced</option>
            <option value="Separated">Separated</option>
          </select>
        </label>

        <label>
          Postal Address
          <textarea
            name="postalAddress"
            value={formData.postalAddress}
            onChange={handleInputChange}

          ></textarea>
        </label>

        <label>
          Residential Address<span className="required-indicator">*</span>
          <textarea
            name="residentialAddress"
            value={formData.residentialAddress}
            onChange={handleInputChange}
            className={unfilledFields.includes('residentialAddress') ? 'unfilled' : ''}
            required
          ></textarea>
        </label>

        <label>
          Phone No
          <input
            type="tel"
            name="phoneNo"
            value={formData.phoneNo}
            onChange={handleInputChange}
            
          />
        </label>

        <label>
          Cell No<span className="required-indicator">*</span>
          <input
            type="tel"
            name="cellNo"
            value={formData.cellNo}
            onChange={handleInputChange}
            className={unfilledFields.includes('cellNo') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Email<span className="required-indicator">*</span>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            className={unfilledFields.includes('email') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Nationality<span className="required-indicator">*</span>
          <input
            type="text"
            name="nationality"
            value={formData.nationality}
            onChange={handleInputChange}
            className={unfilledFields.includes('nationality') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Citizenship<span className="required-indicator">*</span>
          <input
            type="text"
            name="citizenship"
            value={formData.citizenship}
            onChange={handleInputChange}
            className={unfilledFields.includes('citizenship') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Ethnicity<span className="required-indicator">*</span>
          <input
            type="text"
            name="ethnicity"
            value={formData.ethnicity}
            onChange={handleInputChange}
            className={unfilledFields.includes('ethnicity') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Home Language<span className="required-indicator">*</span>
          <input
            type="text"
            name="homeLanguage"
            value={formData.homeLanguage}
            onChange={handleInputChange}
            className={unfilledFields.includes('homeLanguage') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          ID or Passport No<span className="required-indicator">*</span>
          <input
            type="text"
            name="idOrPassportNo"
            value={formData.idOrPassportNo}
            onChange={handleInputChange}
            className={unfilledFields.includes('idOrPassportNo') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          VISA/Permit Status
          <input
            type="text"
            name="visaPermitStatus"
            value={formData.visaPermitStatus}
            onChange={handleInputChange}
            className={unfilledFields.includes('visaPermitStatus') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Church Affiliation
          <input
            type="text"
            name="churchAffiliation"
            value={formData.churchAffiliation}
            onChange={handleInputChange}
        
          />
        </label>

        <label>
          Occupation<span className="required-indicator">*</span>
          <input
            type="text"
            name="occupation"
            value={formData.occupation}
            onChange={handleInputChange}
            className={unfilledFields.includes('occupation') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Highest Education Level Completed<span className="required-indicator">*</span>
          <input
            type="text"
            name="highestEducationLevel"
            value={formData.highestEducationLevel}
            onChange={handleInputChange}
            className={unfilledFields.includes('highestEducationLevel') ? 'unfilled' : ''}
            required
          />
        </label>

        <label>
          Disability (Y/N)<span className="required-indicator">*</span>
          <select
            name="disability"
            value={formData.disability}
            onChange={handleInputChange}
            className={unfilledFields.includes('disability') ? 'unfilled' : ''}
            required
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </label>

        {formData.disability === 'Yes' && (
          <label>
            If “Yes” please specify:
            <input
              type="text"
              name="disability"
              value={formData.disability}
              onChange={handleInputChange}
              required={formData.disability === 'Yes'}
            />
          </label>
        )}

        <label>
          Are you currently studying with another institution (Y/N)?<span className="required-indicator">*</span>
          <select
            name="otherInstitution"
            value={formData.otherInstitution}
            onChange={handleInputChange}
            className={unfilledFields.includes('otherInstitution') ? 'unfilled' : ''}
            required
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </label>
 
        {formData.otherInstitution === 'Yes' && (
          <label>
            If “Yes” please specify:
            <input
              type="text"
              name="otherInstitution"
              // value={formData.otherInstitution}
              onChange={handleInputChange}
              required={formData.otherInstitution === 'Yes'}
            />
          </label>
        )}

        <label>
          How did you hear about us?
          <input
            type="text"
            name="howDidYouHear"
            value={formData.howDidYouHear}
            onChange={handleInputChange}
          />
        </label>
        <div className="buttons">
        <button onClick={handleNext}>Next</button>
         </div>
      </div>
    </div>
  );
};

export default Step1;
